import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule, } from "vuex-module-decorators";
import store from "../../store";
let layoutModule = /** @class */ (() => {
    let layoutModule = class layoutModule extends VuexModule {
        constructor() {
            super(...arguments);
            // STATE
            this.layoutType = "vertical";
            this.layoutWidth = "fluid";
            this.leftSidebarType = "dark";
            this.topbar = "dark";
            this.loader = false;
        }
        SetLayout(layoutType) {
            this.layoutType = layoutType;
        }
        SetLayoutWidth(layoutWidth) {
            this.layoutWidth = layoutWidth;
        }
        SetLeftSidebarType(leftSidebarType) {
            this.leftSidebarType = leftSidebarType;
        }
        SetTopbar(topbar) {
            this.topbar = topbar;
        }
        SetLoader(loader) {
            this.loader = loader;
        }
        async ChangeLayoutType(layoutType) {
            this.SetLayout(layoutType);
        }
        async ChangeLayoutWidth(layoutWidth) {
            this.SetLayoutWidth(layoutWidth);
        }
        async ChangeLeftSidebarType(leftSidebarType) {
            this.SetLeftSidebarType(leftSidebarType);
        }
        async ChangeTopbar(topbar) {
            this.SetTopbar(topbar);
        }
        async ChangeLoader(loader) {
            this.SetLoader(loader);
        }
    };
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], layoutModule.prototype, "SetLayout", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], layoutModule.prototype, "SetLayoutWidth", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], layoutModule.prototype, "SetLeftSidebarType", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], layoutModule.prototype, "SetTopbar", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], layoutModule.prototype, "SetLoader", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], layoutModule.prototype, "ChangeLayoutType", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], layoutModule.prototype, "ChangeLayoutWidth", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], layoutModule.prototype, "ChangeLeftSidebarType", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], layoutModule.prototype, "ChangeTopbar", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", Promise)
    ], layoutModule.prototype, "ChangeLoader", null);
    layoutModule = __decorate([
        Module({
            dynamic: true,
            store: store,
            name: "layout",
            namespaced: true,
        })
    ], layoutModule);
    return layoutModule;
})();
export default getModule(layoutModule);
